export const MOCKED_ARTICLE_NUMBER = 6;

export const TOPIC_DATA_SEO: Record<
  string,
  { title: string; description: string }
> = {
  bewerbungUebersicht: {
    title: 'CAREER_HUB_TOPIC_PAGE_BEWERBUNG_UEBERSICHT_TITLE',
    description: 'CAREER_HUB_TOPIC_PAGE_BEWERBUNG_UEBERSICHT_DESCRIPTION',
  },
};

export const TITLE = 'Alle Artikel zum Thema Bewerbung';

export const INTRODUCTORY_TEXT =
  'Du zeigst mit Deiner topaktuellen Bewerbung, dass Du die Trends rund ums Thema Recruiting kennst. Mit diesen Infos entscheidest Du in wenigen Sekunden, was heute in eine gute Bewerbung hineingehört. Und auch, was nicht. Recruiter·innen sehen also sofort, dass Du weißt, wie’s geht. Dieser erste gute Eindruck macht Dich in einer sich ständig verändernden Arbeitswelt mehr als nur wettbewerbsfähig.';

export const BUTTON_TEXT = 'Zu den Tipps';

export const TO_ARTICLE = 'Alle Artikel';
